import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { METHOD_TEXT, OFFER_ANCHOR } from '../data/constants';
export function Hero() {
  return <section className="border-b-4 border-tech bg-white" data-id="element-81" data-mp="9ll8uwe5pwmz">
      <div className="h-1.5 bg-navy" aria-hidden="true" data-id="element-82" data-mp="4lyuukqi8cd4" />
      <div className="h-1 bg-alert" aria-hidden="true" data-id="element-83" data-mp="4njrqh0ak7e5" />
      <div className="mx-auto max-w-5xl px-4 pb-5 pt-3 sm:px-6 sm:pb-7 sm:pt-5" data-id="element-84" data-mp="129qurmgy5roe">
        <h1 className="mx-auto max-w-4xl text-center text-2xl leading-display text-navy sm:text-5xl" data-id="element-85" data-mp="xanojyp8dfeu">
          IDENTIFIEZ LES CARENCES NUTRITIONNELLES{' '}
          <span className="text-tech-dark" data-id="element-86" data-mp="s9ggrzn38g86">ET DÉCIDEZ AVEC MÉTHODE, SANS INTERVENIR AU HASARD</span>
        </h1>
        <p className="mx-auto mt-2 max-w-3xl rounded-lg bg-navy px-3 py-1.5 text-center font-display text-sm font-bold uppercase leading-tight text-white sm:text-lg" data-id="element-87" data-mp="neauv0tor1k3">
          DES FEUILLES JAUNISSENT…{' '}
          <span className="text-alert" data-id="element-88" data-mp="384s4wnk2qj2j">MAIS SAVEZ-VOUS VRAIMENT CE QUE LA PLANTE VOUS SIGNALE ?</span>
        </p>

        <p className="mx-auto mt-2 max-w-3xl text-center text-sm leading-snug text-steel sm:text-base" data-id="element-89" data-mp="3o7lv7zxu9mt6">
          Le système complet de diagnostic visuel, d’analyse nutritionnelle et de solutions
          pratiques pour les cultures : atlas des symptômes, tableaux de référence, arbres de
          décision et fiches de terrain{' '}
          <strong className="font-semibold text-navy" data-id="element-90" data-mp="30gzu6sm952so">
            pour avancer étape par étape : {METHOD_TEXT}.
          </strong>
        </p>

        <MockupImage className="mt-2" priority data-id="element-91" data-mp="35akly2x950jf" />

        <div className="mt-2 flex flex-col items-center" data-id="element-92" data-mp="2qkwk90l5rzv6">
          <CTAButton href={OFFER_ANCHOR} data-id="element-93" data-mp="2viy2jjarfv5l">🌿 OUI ! JE VEUX LE SYSTÈME COMPLET</CTAButton>
          <TrustLine items={['🛡️ Garantie satisfait ou remboursé de 7 jours', '🌿 Système complet 6 en 1']} data-id="element-94" data-mp="2vglmxcsh5wvp" />
        </div>
      </div>
    </section>;
}